export default "__VITE_ASSET__YlCcaFJ3__"